  <template>
  <div class="skinnedmenu dropdown" style="position: relative; color: inherit;display:inline-table">
    <input type="text" v-model="typedValue" data-toggle="dropdown" @click="" />
    <div class="skinnedmenu dropdown-menu dropdown-menu-left viewportfix pt-1" style="position:absolute">
      <a v-for="(el, index) in getOptions()" @click="doChange(el)" href="#" class="dropdown-item"><span v-if="el.text == null || el.text == ''">[{{el.id}}]</span><span v-if="el.text != null && el.text != ''">{{el.text}}</span></a>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'input-select4',
    components: {
    },
    data() {
      return {
        array: [],
        selValue: '',
        typedValue: ''
      };
    },
    props: {
      value: {
        required: false,
        type: String,
        default: null
      },
      options: {
        required: false,
        type: Array,
        default() {
          return []
        }
      },
      idcolumnname: {
        required: false,
        type: String,
        default: null
      },
      textcolumnname: {
        required: false,
        type: String,
        default: null
      },
    },
    methods: {
      doChange(el) {
        this.value = el.id;
        this.selected = el.id;
      },
      getId() {
        return this._uid;
      },
      realValue() {
        return this.array;
      },
      getOptions() {
        var arr = [];
        var selectedValue = "";
        arr.push({ id: -1, text: 'new' });
        if (this.idcolumnname != null && this.textcolumnname != null) {
          for (var i = 0; i < this.options.length; i++) {
            //arr.push({ id: (this.options[i][this.idcolumnname]).toString(), text: this.shortenName(this.options[i][this.textcolumnname]) });
            if (arr[i].id === this.value) {
              selectedValue = arr[i].text;
            }
            if (this.typedValue != "" && this.options[i][this.textcolumnname].toLowerCase().indexOf(this.typedValue) == 0) {
              arr.push({ id: (this.options[i][this.idcolumnname]).toString(), text: this.shortenName(this.options[i][this.textcolumnname]) });
            }
            else
              arr.push({ id: (this.options[i][this.idcolumnname]).toString(), text: this.shortenName(this.options[i][this.textcolumnname]) });

          }
        }
        else {
          for (var i = 0; i < this.options.length; i++) {
            //arr.push({ id: this.options[i].toString(), text: this.shortenName(this.options[i]) });
            if (arr[i].id === this.value) {
              selectedValue = arr[i].text;
            }
            if (this.typedValue != "" && this.options[i].indexOf(this.typedValue) == 0) {
              arr.push({ id: this.options[i].toString(), text: this.shortenName(this.options[i]) });
            }
            else
              arr.push({ id: this.options[i].toString(), text: this.shortenName(this.options[i]) });
          }
        }

        if (selectedValue == "" && this.value != null)
          selectedValue = this.value;
        if (selectedValue.length > 10) {
          selectedValue = selectedValue.substring(0, 7) + "...";
        }

        this.selValue = selectedValue;
        this.array = arr;
        Vue.set(this, "array", arr);
        return arr;
      },
      valueText() {
        var retVal = "";
        for (var i = 0; i < this.array.length; i++) {
          if (this.array[i].id === this.value) {
            retVal = this.array[i].text;
          }
        }
        if (retVal == "" && this.value != null)
          retVal = this.value;
        if (retVal.length > 10) {
          retVal = retVal.substring(0, 7) + "...";
        }
        return retVal;
      },
      shortenName(name) {
        if (name == null)
          return null;
        if (name.length > 25)
          name = name.substring(0, 22) + "...";
        return name;
      }
    },
    created() {

    },
    mounted() {

    },
    computed: {
     
      selected: {
        get() { return this.value },
        set(v) { this.$emit('input', v) }
      }
     
    },
    watch: {
      value: function (newVal, oldVal) {
        this.$forceUpdate();
      },
      options: function (newVal, oldVal) {
        var arr = [];
        if (this.idcolumnname != null && this.textcolumnname != null) {
          for (var i = 0; i < newVal.length; i++) {
              arr.push({ id: (newVal[i][this.idcolumnname]).toString(), text: this.shortenName(newVal[i][this.textcolumnname]) });
          }
        }
        else {
          for (var i = 0; i < newVal.length; i++) {
            arr.push({ id: newVal[i].toString(), text: this.shortenName(newVal[i]) });
          }
        }
        this.array = arr;
        Vue.set(this, "array", arr);
        this.$forceUpdate();
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/form-components/input-select4.vue